import React, {useState, useEffect} from 'react'
import _ from 'lodash'
import {Popover, Grid} from '@material-ui/core'
import FilterSelectValue from './FilterSelectValue'
import FilterFIelds from './FilterFIelds'
import FilterFieldItems from './FilterFieldItems'
import {normalizeFieldValues} from './utils'
import useCalendarViewContext from '../../../../../context/CalendarView'

const PopFilterToggle = ({
  options = [],
  open,
  value,
  onClickOption,
  onClose,
  anchorEl,
  objects,
  filters = null,
  groupView,
  setGroupView,
  setFilterExpand,
}) => {
  const [selectedField, setSelectedField] = useState({})
  const {
    sharableFilters,
    setSharableFilters,
    viewData,
    setViewData,
    sharableFilterFieldValues,
  } = useCalendarViewContext()

  const handleClose = e => {
    if (onClose) {
      onClose(e, sharableFilters)
    }
    setSelectedField({})
  }

  useEffect(() => {
    if (open) {
      if (sharableFilters.length > 0 && _.isEmpty(selectedField)) {
        const t = sharableFilters[0]
        setSelectedField({
          field_id: t.id,
          key: t.key,
          field_name: t.field_name,
        })
      } else if (groupView.filters) {
        if (groupView?.filters.length > 0 && _.isEmpty(selectedField)) {
          if (viewData.selectedFilterValueFields.length === 0) {
            selectedField?.field_id && setSelectedField({})
          } else {
            const t = groupView?.filters[0]
            setSelectedField({
              field_id: t.field_id,
              key: t.key,
            })
          }
        }
      }
    }
    //eslint-disable-next-line
  }, [sharableFilters, open, selectedField])

  useEffect(() => {
    if (open && !!filters) {
      setSharableFilters(filters)
    }
  }, [filters, open, setSharableFilters])

  const handleApplyFilter = e => {
    if (onClose) {
      onClose(e, sharableFilters)
    }
    setSelectedField({})
    setViewData({...viewData, selectedFilterValueFields: sharableFilters})
    setFilterExpand(true)
  }
  const handleClickOption = (e, t) => {
    setSelectedField(t)
  }
  const checkFilterFieldExists = currentId => {
    let op = false
    sharableFilters.map(f => {
      if (f.id === currentId) {
        op = true
      }
      return true
    })
    return op
  }
  const updatesharableFilters = (id, val, data, isAll = false) => {
    let _sharableFilters = sharableFilters.reduce((ret, sf) => {
      if (sf.id === id) {
        if (isAll) {
          let normalizedValues = normalizeFieldValues(
            sharableFilterFieldValues.data.field_type,
            sharableFilterFieldValues.data.values
          )
          let allValues = [{value: 'no_value'}, ...normalizedValues]
          sf.value = allValues.map(nv => {
            return nv.value
          })

          const new_values = []
          allValues.map(nv => {
            return new_values.push({
              id: nv?.label === nv.value ? nv.label.replace(' ', '_') : nv.value,
              value: nv?.label ? nv.label : nv.value,
            })
          })
          sf.values = new_values
        } else {
          const new_arr = sf && sf.new_values ? [...sf.new_values] : []
          new_arr.push({
            id: data?.label === data.value ? data.label.replace(' ', '_') : data.value,
            value: data.label,
          })
          sf.new_values = new_arr
          // get index
          const _index = sf.value.indexOf(val)
          //  if exist
          if (_index !== -1) {
            sf.value.splice(_index, 1)
          } else {
            sf.value = [...sf.value, val]
          }
        }
      }
      if (sf.value.length > 0) {
        return [...ret, sf]
      }
      return ret
    }, [])
    setSharableFilters(_sharableFilters)
  }
  const handleClickValueOption = (e, t, o) => {
    if (checkFilterFieldExists(selectedField.field_id)) {
      if (t === 'select_all') {
        updatesharableFilters(selectedField.field_id, t, o, true)
      } else {
        updatesharableFilters(selectedField.field_id, t, o)
      }
    } else {
      if (t === 'select_all') {
        let normalizedValues = normalizeFieldValues(
          sharableFilterFieldValues.data.field_type,
          sharableFilterFieldValues.data.values
        )
        let allValues = [{value: 'no_value'}, ...normalizedValues]
        const new_values = []
        allValues.map(nv => {
          return new_values.push({
            id: nv?.label === nv.value ? null : nv.value,
            value: nv?.label ? nv.label : nv.value,
          })
        })
        setSharableFilters([
          ...sharableFilters,
          {
            id: selectedField.field_id,
            key: selectedField.key,
            field_name: selectedField.field_name,
            value: allValues.map(nv => {
              return nv.value
            }),
            values: new_values,
          },
        ])
      } else {
        const new_arr = []
        new_arr.push({
          id: o?.label === o.value ? o.label.replace(' ', '_') : o.value,
          value: o?.label ? o.label : o.value,
        })
        setSharableFilters([
          ...sharableFilters,
          {
            id: selectedField.field_id,
            key: selectedField.key,
            field_name: selectedField.field_name,
            value: [t],
            values: {
              id: o?.label === o.value ? o.label.replace(' ', '_') : o.value,
              value: o?.label ? o.label : o.value,
            },
            new_values: new_arr,
          },
        ])
      }
    }
  }
  const handleClickSelectedValueOption = (e, t) => {
    if (onClickOption) {
      onClickOption(e, t)
    }
    setSelectedField({
      field_id: t.id,
      key: t.key,
      field_name: t.field_name,
    })
  }
  const handleCloseValueOption = (e, t) => {
    let _sharableFilters = []
    sharableFilters.map(sf => {
      if (sf.id !== t.id) {
        _sharableFilters.push(sf)
      }
      return true
    })
    setSharableFilters(_sharableFilters)
    setViewData({...viewData, selectedFilterValueFields: _sharableFilters})
  }
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      // classes={{
      //   paper: 'c-pop-field-toggle',
      // }}
      keepMounted
      className="filter-main-popup"
    >
      <Grid container className={`filter-popup-main`}>
        {!!sharableFilters.length && (
          <Grid item className="height-100-per">
            <FilterSelectValue
              options={options}
              handleClickSelectedValueOption={handleClickSelectedValueOption}
              handleCloseValueOption={handleCloseValueOption}
              value={selectedField}
              values={sharableFilters}
              handleApplyFilter={handleApplyFilter}
              setSharableFilters={setSharableFilters}
            />
          </Grid>
        )}
        <Grid item className="height-100-per">
          <FilterFIelds
            options={options}
            handleClickOption={handleClickOption}
            value={selectedField}
            values={sharableFilters}
            open={open}
          />
        </Grid>
        <Grid item className="height-100-per">
          <FilterFieldItems
            options={options}
            field={selectedField}
            objects={objects}
            handleClickValueOption={handleClickValueOption}
            value={value}
            values={sharableFilters}
            setSharableFilters={setSharableFilters}
          />
        </Grid>
      </Grid>
    </Popover>
  )
}
export default PopFilterToggle
